import React from "react";
import "./About.scss";
import OfficeImg from "../../assets/office.jpg";
import CEOImg from "../../assets/ceo.png";
import VPImg from "../../assets/vp.png";
import COOImg from "../../assets/coo.png";
import CFOImg from "../../assets/cfo.png";

interface IListItem {
  name: string;
  link?: string;
}

interface ICustomers {
  entity: string;
  departments: IListItem[];
}

export const About: React.FC = () => {
  return (
    <div className="About">
      <div className="About_header page-header">
        <h1>About Us</h1>
        <div>
          <p>
            From our inception in 1984 to the present, we have had a single
            focus: to provide integrated solutions that exceed customer
            expectations in every performance area, by fostering an environment
            where PROSOFT employees continue to thrive.
          </p>
        </div>
      </div>
      <div className="About__content">
        <div className="About__Who About__section" id="About_Who">
          <h2 className="section-header">Who we are</h2>
          <div className="About__section__content About__Who__content">
            <div className="About__Who__content__subsection">
              <h3 className="left-green-border">History of PROSOFT</h3>
              <div className="About__Who__content__subsection__text">
                <p>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro
                  vero quidem quam nesciunt sunt modi, voluptatum odit labore
                  cupiditate rerum officiis laborum adipisci molestiae, ipsam
                  perferendis, sint incidunt atque ab? Magnam, aperiam, dolores
                  minima quidem sint porro aliquam facilis, dolore similique
                  molestias doloremque adipisci harum eos ipsam rerum ad.
                  Dolores pariatur placeat mollitia commodi nam molestias qui
                  quasi sit perspiciatis deserunt magnam asperiores, incidunt,
                  expedita enim omnis at ipsam, voluptas laborum repudiandae vel
                  corporis itaque. Aut, consequuntur quidem earum numquam
                  placeat praesentium delectus cumque nemo eveniet nulla, sint
                  ipsam quos magni officia eligendi voluptate adipisci impedit.
                  Consequuntur libero cum fuga facere quae? Atque reprehenderit
                  eligendi hic corrupti, consequatur aliquam eaque aut quos,
                  laboriosam magnam iure voluptatum, dolorem voluptatem dolores
                  ipsum repellat debitis. Totam natus omnis doloribus ipsam eius
                  mollitia. Doloribus doloremque nihil vel inventore quas
                  praesentium aliquam similique recusandae illo. Nihil rerum
                  neque ducimus eveniet sunt magni tempore repudiandae soluta?
                </p>
              </div>
            </div>
            <div className="About__Who__content__subsection">
              <h3 className="left-green-border">Small Business Status</h3>
              <div className="About__Who__content__subsection__text">
                <p>
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                  Doloremque cumque maiores vero non, dolorum error distinctio
                  debitis quas dignissimos in id fugiat! Saepe incidunt ipsam
                  esse tempora ratione officiis odit architecto ullam? Saepe,
                  expedita quas. Minus aliquid laboriosam labore at quibusdam
                  laudantium reiciendis facilis libero ipsum excepturi velit
                  soluta maiores, fugit omnis assumenda? Repellendus
                  exercitationem inventore amet debitis excepturi reiciendis
                  consequuntur esse vero vitae, modi sed velit quis quasi ut.
                  Fuga exercitationem aliquam nobis ea explicabo et facilis
                  repellat dolores?
                </p>
              </div>
            </div>
            <div className="About__Who__content__subsection">
              <h3 className="left-green-border">Quality</h3>
              <div className="About__Who__content__subsection__text">
                <p>
                  We have an uncompromising commitment to providing ourcustomers
                  with quality technical products and services, while meeting
                  high moral and ethical standards in the performance of our
                  jobs. True Quality Assurance is the result of management
                  commitment, dedication, and hard work throughout every level
                  of our organization. Quality is an integral part of our
                  operations and is evident in every aspect of our business, and
                  PROSOFT enjoys an exceptional record of corporate performance.
                </p>
                <p>
                  The objective of PROSOFT's Quality Policy is to exceed the
                  needs and expectations of our customers by providing highly
                  skilled professionals. We attribute our success to our
                  best-in-class personnel supported by a corporate culture that
                  endorses the continual training, education, and empowerment of
                  our employees in the delivery of quality technical products
                  and services. Our active, company-wide Quality Management
                  System provides an environment to establish, communicate, and
                  review the quality objectives that enable us to continually
                  cultivate success. PROSOFT ISOand our employees commit to
                  continuously improve the processes by which we provide our
                  services and products, so that our work meets requirements,
                  and is done right the first time. PROSOFT is a registered ISO
                  9001 and an appraised CMMI-DEV ML3 corporation.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="About_Locations About__section" id="About_Locations">
          <h2 className="section-header">Locations</h2>
          <div className="About__section__content">
            <div className="Locations__header">
              <img
                className="Locations__header__img"
                src={OfficeImg}
                alt="Corporate Office Building"
              />
              <p className="Locations__header__text">
                We are headquartered in Virginia Beach, VA, with technical
                engineering and administrative staff serving in various
                locations.
              </p>
            </div>
            <div className="headquarters">
              <div className="headquarters__va headquarters__card">
                <span className="headquarters-title">Virginia Beach, VA</span>
                <div className="headquarters__card__body">
                  <span>500 Viking Dr. - Suite 301</span>
                  <span>Virginia Beach, VA 23452</span>
                  <span>Phone: (757) 431-2400</span>
                  <span>Fax: (757) 463-1071</span>
                </div>
              </div>
              <div className="headquarters__sc headquarters__card">
                <span className="headquarters-title">Hanahan, SC</span>
                <div className="headquarters__card__body">
                  <span>1002 Trident Street - Suite 200</span>
                  <span>Hanahan, SC 29410</span>
                  <span>Phone: (843) 225-2142</span>
                </div>
              </div>
            </div>
            <div className="service-areas">
              <h3>Serving the following areas:</h3>
              <ul className="service-areas__locations">
                <li>Virigina Beach, VA</li>
                <li>Norfolk, VA</li>
                <li>Suffolk, VA</li>
                <li>Chesapeake, VA</li>
                <li>Charleston, SC</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="About__section About_officers">
          <h2 className="section-header">Meet our Corporate Officers</h2>
          <div className="About_officers__cards About__section__content">
            <div className="About_officers__cards__card">
              <div className="About_officers__cards__card__header">
                <img src={CEOImg} alt="CEO" />
                <div>
                  <span>President & CEO - Co-founder</span>
                </div>
              </div>
              <div className="About_officers__cards__card__body">
                <h4>Paul K. Wong</h4>
                <p>
                  Oversees the management of the company's strategic, financial,
                  and operational activities worldwide.
                </p>
                <hr />
                <p>
                  Mr. Wong holds a B.S. in Electrical Engineering from Virginia
                  Tech, 1980.
                </p>
              </div>
            </div>
            <div className="About_officers__cards__card">
              <div className="About_officers__cards__card__header">
                <img src={VPImg} alt="Vice President" />
                <div>
                  <span>Vice President - Co-founder</span>
                </div>
              </div>
              <div className="About_officers__cards__card__body">
                <h4>Michael D. Adolphi</h4>
                <p>
                  Responsible for assisting the President in the management of
                  the company's business strategic planning and execution. Mr.
                  Adolphi is also responsible for management of special R&D
                  projects.
                </p>
                <hr />
                <p>
                  Mr. Adolphi holds a B.S. in Electrical Engineering from
                  Virginia Tech, 1982 and holds a Masters in Electrical
                  Engineering from Old Dominion University, 2000.
                </p>
              </div>
            </div>
            <div className="About_officers__cards__card">
              <div className="About_officers__cards__card__header">
                <img src={COOImg} alt="COO" />
                <div>
                  <span>Chief Operating Officer</span>
                </div>
              </div>
              <div className="About_officers__cards__card__body">
                <h4>Karen Hinson</h4>
                <p>
                  Karen Hinson joined PROSOFT in 1994. Ms. Hinson is responsible
                  for the executive management of the company's day-to-day
                  operating activities and is the Program Manager for the System
                  and Software Engineering Group.
                </p>
                <hr />
                <p>
                  Ms. Hinson holds a B.A. in Graphic Art from Virginia Tech,
                  1988 and is a certified Project Management Institute (PMI)
                  Project Management Professional (PMP).
                </p>
              </div>
            </div>
            <div className="About_officers__cards__card">
              <div className="About_officers__cards__card__header">
                <img src={CFOImg} alt="CFO" />
                <div>
                  <span>Chief Financial Officer</span>
                </div>
              </div>
              <div className="About_officers__cards__card__body">
                <h4>Philip M. Eagan</h4>
                <p>
                  Joined PROSOFT in 1992. Mr. Eagan is responsible for the
                  executive management of the company's Finance and Contracts
                  Department and is the Small Business Liaison Officer (SBLO) .
                </p>
                <hr />
                <p>
                  Mr. Eagan holds a B.S. in Accounting from Virginia Tech, 1979,
                  and is a Certified Public Accountant.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="About__section About__eeoc">
          <h2 className="section-header">EEOC & Diversity</h2>
          <div className="About__section__content About__eeoc__content">
            <p>
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Qui
              dolore maxime dicta laudantium quaerat ea ex eaque illum, adipisci
              quam voluptates nisi officia hic nesciunt incidunt consectetur.
              Laudantium beatae sapiente quaerat debitis magni, praesentium
              delectus ea sit, cumque ab id recusandae architecto molestias
              voluptatibus vero nesciunt nam enim quos. Explicabo!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
